import SectionHeading from "./SectionHeading";
import { hotRanking } from "@/mocks/site";

const trendMap: Record<string, { icon: string; label: string; cls: string }> = {
  new: { icon: "ri-sparkling-2-line", label: "新上榜", cls: "text-accent-600 bg-accent-100" },
  up: { icon: "ri-arrow-up-line", label: "上升", cls: "text-primary-700 bg-primary-100" },
  flat: { icon: "ri-subtract-line", label: "持平", cls: "text-secondary-700 bg-secondary-100" },
  down: { icon: "ri-arrow-down-line", label: "下降", cls: "text-foreground-500 bg-background-200" },
};

const rankColor = (rank: number) => {
  if (rank === 1) return "text-primary-500";
  if (rank === 2) return "text-accent-500";
  if (rank === 3) return "text-secondary-500";
  return "text-foreground-300";
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHeading
            eyebrow="热门榜单 · 每日更新"
            title="今日漫画热榜 Top 10"
            desc="综合近期阅读量、收藏变化与更新活跃度实时排序。榜单每天刷新一次，趋势标识可帮你判断一部作品是正在冲榜还是热度回落。"
          />
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm px-4 py-2">
            <i className="ri-refresh-line" aria-hidden="true"></i>
            数据每小时同步
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {[hotRanking.slice(0, 5), hotRanking.slice(5)].map((column, ci) => (
            <ol key={ci} className="flex flex-col gap-3">
              {column.map((item) => {
                const trend = trendMap[item.trend];
                return (
                  <li
                    key={item.rank}
                    className="group flex items-center gap-3 md:gap-4 rounded-lg border border-background-200/70 bg-background-100/60 px-4 py-3 hover:border-primary-300 hover:bg-primary-50/60 transition-colors"
                  >
                    <span className={`font-heading text-3xl md:text-4xl leading-none w-9 text-center shrink-0 ${rankColor(item.rank)}`}>
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="font-medium text-foreground-950 text-sm md:text-base truncate">
                          {item.title}
                        </h3>
                        <span className="rounded-full bg-background-200 text-foreground-600 text-xs px-2 py-0.5 whitespace-nowrap">
                          {item.category}
                        </span>
                      </div>
                      <p className="mt-0.5 text-foreground-500 text-xs md:text-sm truncate">{item.note}</p>
                    </div>
                    <div className="flex flex-col items-end gap-1 shrink-0">
                      <span className="font-heading text-primary-600 text-lg leading-none">{item.hot}</span>
                      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] ${trend.cls}`}>
                        <i className={trend.icon} aria-hidden="true"></i>
                        {trend.label}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ol>
          ))}
        </div>
      </div>
    </section>
  );
}